export default function openUrl(url: string): void {
  if (window.cordova) {
    // @ts-ignore
    // eslint-disable-next-line
    window.cordova.InAppBrowser.open(url, '_system');
  } else {
    window.open(url, '_blank');
  }
}
